import swal from 'sweetalert2';
import { Table, TableColumn, Button, Select, Option } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ResourceSvc from '@/services/resource.svc.js';
import { Pagination as LPagination } from '@/components/index';
import { clubBackRouteMixin } from '../mixins/club-back-route.js';
const svc = new ResourceSvc();

export default {
    name: 'viewClubMembers',
    mixins: [clubBackRouteMixin],
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        'l-pagination': LPagination,
    },
    data() {
        return {
            clubId: null,
            year: null,
            termsAccepted: false,
            isLoading: false,
            members: [],
            canRemoveMembers: false,
            showOnlyFlagged: false,
            errorMessage: null,
            isExporting: false,
            searchQuery: '',
            pagination: {
                perPage: 25,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            }
        };
    },
    computed: {
        filteredMembers() {
            let result = this.members;
            if (this.showOnlyFlagged) {
                result = result.filter(m => m.isFlagged);
            }
            if (this.searchQuery) {
                const q = this.searchQuery.toLowerCase();
                result = result.filter(m =>
                    (m.fullName || '').toLowerCase().includes(q) ||
                    String(m.tiNumber || '').includes(q) ||
                    (m.email || '').toLowerCase().includes(q)
                );
            }
            return result;
        },
        pagedMembers() {
            const start = this.pagination.perPage * (this.pagination.currentPage - 1);
            const end = start + this.pagination.perPage;
            return this.filteredMembers.slice(start, end);
        }
    },
    watch: {
        filteredMembers(val) {
            this.pagination.total = val.length;
            this.pagination.currentPage = 1;
        }
    },
    mounted() {
        this.clubId = parseInt(this.$route.params.id);
        this.year = parseInt(this.$route.query.year, 10) || null;
    },
    methods: {
        acceptTerms() {
            this.termsAccepted = true;
            this.loadMembers();
        },
        declineTerms() {
            this.$router.go(-1);
        },
        loadMembers() {
            this.isLoading = true;
            this.errorMessage = null;
            svc.getClubMembers(this.clubId, this.year).then(response => {
                var data = response.body;
                if (data && data.isSuccess) {
                    var result = data.outputData;
                    this.members = result.members || [];
                    this.canRemoveMembers = result.canRemoveMembers || false;
                    this.pagination.total = this.members.length;
                } else {
                    this.errorMessage = (data && data.message) || 'Failed to load members';
                }
                this.isLoading = false;
            }, error => {
                this.errorMessage = 'Failed to load members';
                this.isLoading = false;
            });
        },
        toggleFlagFilter() {
            this.showOnlyFlagged = !this.showOnlyFlagged;
        },
        toggleFlag(member) {
            var newFlag = !member.isFlagged;
            svc.toggleMemberFlag(member.id, this.clubId, newFlag, this.year).then(response => {
                var data = response.body;
                if (data && data.isSuccess) {
                    member.isFlagged = newFlag;
                } else {
                    alert((data && data.message) || 'Failed to update flag');
                }
            }, error => {
                alert('Failed to update flag');
            });
        },
        removeMember(member) {
            var self = this;
            swal({
                title: 'Please confirm',
                text: 'Are you sure you want to remove ' + member.fullName + ' (TI #' + member.tiNumber + ') from the club? This cannot be undone.',
                type: 'warning',
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-default',
                cancelButtonClass: 'btn btn-danger',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(function (result) {
                if (result.value) {
                    svc.removeClubMember(member.id, self.clubId, self.year).then(response => {
                        var data = response.body;
                        if (data && data.isSuccess) {
                            var idx = self.members.findIndex(function(m) { return m.id === member.id; });
                            if (idx !== -1) self.members.splice(idx, 1);
                        } else {
                            self.$notify({ message: (data && data.message) || 'Failed to remove member', type: 'danger' });
                        }
                    }, function() {
                        self.$notify({ message: 'Failed to remove member', type: 'danger' });
                    });
                }
            });
        },
        exportToExcel() {
            this.isExporting = true;
            const url = '/api/Club/ExportClubMembers?clubId=' + this.clubId + (this.year ? '&year=' + this.year : '');
            fetch(url, { credentials: 'same-origin' })
                .then(response => {
                    if (!response.ok) throw new Error('Export failed');
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'ClubMembers.xlsx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                })
                .catch(() => {
                    this.$notify({ type: 'warning', message: 'Failed to export to Excel' });
                })
                .finally(() => {
                    this.isExporting = false;
                });
        },
        formatAddress(member) {
            return [member.addressLine1, member.addressLine2, member.addressLine3, member.county, member.countyOutsideIreland, member.countryOfResidence]
                .filter(function(p) { return p && p.length > 0; });
        },
        formatContact(member) {
            var parts = [];
            if (member.phone) parts.push('Phone: ' + member.phone);
            if (member.otherPhone) parts.push('Other Phone: ' + member.otherPhone);
            if (member.email) parts.push(member.email);
            return parts;
        },
        formatPayment(member) {
            var parts = [];
            if (member.paymentDate) parts.push(member.paymentDate);
            if (member.paymentPrice != null) parts.push('€ ' + member.paymentPrice);
            return parts;
        },
        formatOptedIn(member) {
            return member.isAutoRenewalEnabled ? 'Yes' : 'No';
        }
    }
};




// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/view-club-members/view-club-members.js